import Accordion from '@commons/components/Accordion';
import RichText from '@commons/components/RichText';
import Text from '@commons/components/Text';
import type { DrupalBlock } from '@commons/types/drupal';

// Type definition for the item properties.

type Item = {
  title: string;
  content: string;
};

// Type definition for the Accordion block component properties.

type Props = DrupalBlock<{
  items: Item[];
}>;

/**
 * Accordion block component.
 */

const AccordionBlock = ({ content }: Props) => {
  const { items = [] } = content;

  const accordionItems = items.map((item) => ({
    title: (
      <Text level="h4" transform="uppercase" marginBottom="none">
        {item.title}
      </Text>
    ),
    children: <RichText width={12} value={item.content} />,
  }));

  return <Accordion items={accordionItems} defaultValue="item-0" className="w-100" />;
};

export default AccordionBlock;
